// Разблокировка v1 — линейная (client-design §8): уровень открыт, если пройден
// предыдущий в порядке (world.index, level.index). «Пройден» = status 'completed':
// по world-01-design «дошёл до портала = пройден», а орбы (rating) — мастерство,
// не гейт (completed с 0 орбов даёт rating 0 и НЕ должен запирать прогресс).
// Граф requires из §8 не заводим, пока прогрессия линейная.

export type NodeState = 'locked' | 'open' | 'done';

/** Набор контента мира = 5 уровней: фон/инструмент/эпизод открываются на стыках
 *  наборов (порог набора n = (n−1)×LEVELS_PER_SET). Единственное место, где живёт
 *  шаг «по 5», — collection.ts и story.ts берут его отсюда, не хардкодят. */
export const LEVELS_PER_SET = 5;

export interface UnlockWorld { id: string; index: number }
export interface UnlockLevel { id: string; world: string; index: number }
export interface UnlockProgressEntry { status?: string }

export function isCompleted(entry: UnlockProgressEntry | undefined): boolean {
  return entry?.status === 'completed';
}

function orderLevels(worlds: UnlockWorld[], levels: UnlockLevel[]): UnlockLevel[] {
  const worldIndex = new Map(worlds.map((w) => [w.id, w.index]));
  return [...levels].sort((a, b) =>
    (worldIndex.get(a.world) ?? 0) - (worldIndex.get(b.world) ?? 0) || a.index - b.index);
}

/** Следующий уровень в линейном порядке (для «Далее» на окне победы);
 *  null — если уровень последний или не из каталога. */
export function nextLevelId(
  worlds: UnlockWorld[],
  levels: UnlockLevel[],
  currentId: string,
): string | null {
  const ordered = orderLevels(worlds, levels);
  const i = ordered.findIndex((l) => l.id === currentId);
  return i >= 0 && i + 1 < ordered.length ? ordered[i + 1].id : null;
}

/** Ядро линейного правила — состояние узла из пары «предыдущий пройден / сам
 *  пройден». Единый канон шага для levelStates и слотов карты
 *  (MapScreen.computeSlots): пройденный остаётся done даже при дыре в прогрессе
 *  (дев-чит) — и открывает следующий. */
export function stepState(prevDone: boolean, done: boolean): NodeState {
  return done ? 'done' : prevDone ? 'open' : 'locked';
}

export function levelStates(
  worlds: UnlockWorld[],
  levels: UnlockLevel[],
  progress: Record<string, UnlockProgressEntry>,
): Record<string, NodeState> {
  const ordered = orderLevels(worlds, levels);

  const states: Record<string, NodeState> = {};
  let prevDone = true; // первый уровень всегда открыт
  for (const level of ordered) {
    const done = isCompleted(progress[level.id]);
    states[level.id] = stepState(prevDone, done);
    prevDone = done;
  }
  return states;
}
